import { request } from '.';
import { setUiState } from './ui';

const SET_CATELOG_PAGES = 'SET_CATELOG_PAGES';
const SET_CATELOG_PAGE = 'SET_CATELOG_PAGE';

const defaultState = { catalog_pages: [], catalog_page: {} };

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case SET_CATELOG_PAGES:
      return { ...state, catalog_pages: action.payload, catalog_page: {} };

    case SET_CATELOG_PAGE:
      return { ...state, catalog_page: action.payload };

    default:
      return state;
  }
}

export function setCatalogPage(catalog_page) {
  return {
    type: SET_CATELOG_PAGE,
    payload: catalog_page
  };
}
export function setCatalogPages(catalog_pages) {
  return {
    type: SET_CATELOG_PAGES,
    payload: catalog_pages
  };
}
export function uploadCatalogPageImage(pId, data) {
  return dispatch =>
    new Promise(async (resolve, reject) => {
      try {
        dispatch(setUiState('loading'));
        const url = `/internal/catalogPages/${pId}/images`;
        await request.post(url, data);
        dispatch(setUiState('complete'));
        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
}

export function getCatalogPage(id) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/internal/catalogPages/${id}`;
        dispatch(setUiState('loading'));
        const response = await request.get(url);
        dispatch(setUiState('complete'));
        dispatch(setCatalogPage(response.data));
        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}

export function updateCatalogPage(id, data) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/internal/catalogPages/${id}`;

        dispatch(setUiState('loading'));
        await request.put(url, data);
        dispatch(setUiState('complete'));

        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}
export function updateCatalogEntityPage(id, data) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/internal/catalogPages/entity/${id}`;

        dispatch(setUiState('loading'));
        await request.put(url, data);
        dispatch(setUiState('complete'));

        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}
export function getCatalogPages() {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/internal/catalogPages`;

        dispatch(setUiState('loading'));
        const response = await request.get(url);
        if (response.data.length > 0) {
          dispatch(setUiState('complete'));
        } else {
          dispatch(setUiState('empty'));
        }

        dispatch(setCatalogPages(response.data));
        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}

export function createCatalogPage(catalog_page) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/internal/catalogPages`;

        dispatch(setUiState('loading'));
        const response = await request.post(url, catalog_page);
        if (response.data.length > 0) {
          dispatch(setUiState('complete'));
        } else {
          dispatch(setUiState('empty'));
        }
        return resolve(response.data);
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}
export function createCatalogPageEntities(entities) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/internal/catalogPages/entities`;

        dispatch(setUiState('loading'));
        const response = await request.post(url, entities);
        if (response.data.length > 0) {
          dispatch(setUiState('complete'));
        } else {
          dispatch(setUiState('empty'));
        }
        return resolve(response.data);
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}
export function removeCatalogPage(id) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/internal/catalogPages/${id}`;

        dispatch(setUiState('loading'));
        await request.delete(url);
        dispatch(setUiState('complete'));

        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}
export function removeCatalogEntity(id) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/internal/catalogPages/entity/${id}`;

        dispatch(setUiState('loading'));
        await request.delete(url);
        dispatch(setUiState('complete'));

        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}
export function checkIceredId(id) {
  return dispatch =>
    new Promise(async resolve => {
      try {
        const url = `/users/icered_id?id=${id}`;
        const response = await request.get(url);

        const isAvailable = response.data.available;
        return resolve(isAvailable);
      } catch (e) {
        return resolve();
      }
    });
}



// WEBPACK FOOTER //
// ./src/redux/catalogPages.js